<script>
export default {
  name: 'ColorPicker',
  data() {
    return {
      selected: this.setting.idx
    }
  },
  methods: {
    on_change(idx) {
      this.selected = idx
      this.$emit('change', this.selected)
    }
  },
  props: {
    setting: {type: Object, default: () => Object()}
  }
}
</script>

<template>
  <div class='d-flex mt-1 flex-wrap'>
    <v-btn v-for='(option, i) in setting.options' :key='i' @click='on_change(i)'
      class='mr-2 mb-2 color-btn' elevation='0' :color='option' fab x-small>
      <v-icon v-if='selected === i' class='check' color='black' x-small>fa-check</v-icon>
    </v-btn>
  </div>
</template>

<style lang='sass' scoped>
.check
  opacity: 0.4

.theme--light
  .color-btn
    border: 1px solid var(--v-grey-base) !important

.theme--dark
  .color-btn
    border: 1px solid var(--v-grey-darken3) !important
</style>
